export const URL_WITH_AUTH = ['/dashboard']

// Paths under /dashboard that should NOT trigger handleInitialize (no institution token yet)
export const URL_SKIP_INIT = ['/dashboard/select-institution']
